import CaptchaSendModal from './CaptchaSendModal';
export default CaptchaSendModal;
